exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Spec[data-v-2edfb4f7] {\n  display: flex;\n  max-height: calc(100vh - 48px);\n  width: 100%;\n}\n.Spec_ScreenEditorDialog[data-v-2edfb4f7] {\n    width: 90vw;\n    height: 95vh;\n}\n.Spec_ScreenEditorDialogActionBar[data-v-2edfb4f7] {\n    padding: 10px;\n}\n", ""]);

// exports
